<template>
  <div class="app-pallets">
    <v-header v-bind:user="user" />
    <packing-types-list :user="user" />
  </div>
</template>

<script>
import VHeader from "../components/header";
import PackingTypesList from "../components/user/packing-types/PackingTypesTable.vue";
import User from "@/models/User.js";

export default {
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    checkUser() {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
      if (!this.user.hasRights("PT_EDIT")) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
  },
  components: {
    VHeader,
    PackingTypesList,
  },
};
</script>